/** The MCP catalog and sign-ins as the profile panel shows them. */

/** The accounts one person can connect to a server. */
export const ACCOUNTS = ["personal", "work"] as const;
export type McpAccount = (typeof ACCOUNTS)[number];
export const ACCOUNT_LABELS: Record<McpAccount, string> = { personal: "个人", work: "工作" };

/**
 * One catalog entry, as the browser is allowed to see it. There is deliberately no
 * `command`/`args`/`env`: the browser picks servers by id and the launch details never cross the wire.
 */
export interface McpCatalogEntry {
	id: string;
	label: string;
	description: string;
	/** Environment variables this server needs that are NOT currently set. Empty when available. */
	requires: string[];
	available: boolean;
	/** Whether using it needs a personal sign-in on top of being enabled on the profile. */
	oauth: boolean;
}

/** The catalog servers a profile lists, as a save returns them and a refused save reports them. */
export interface McpList {
	servers: string[];
	version: string;
}

/** One OAuth server's sign-in state, for the person asking. Never anyone else's. */
export interface McpConnection {
	server: string;
	label: string;
	/** The accounts this server can be connected with; only servers we run ourselves take both. */
	accounts: Array<{ account: McpAccount; connected: boolean; connectedAt?: number }>;
	/** Variables the deployment is missing; signing in is impossible until they are set. */
	missing: string[];
}
